import React, { Component } from 'react';
import { List, Card } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class AppearanceContent extends Component {

    render() {

        const {appearance} = this.props;

        if(!appearance) {
            return null;
        }

        return (
            <Card.Content>
                <List.Item>
                    <FontAwesomeIcon icon='tshirt' /> <Link to={`/appearances/${appearance.Id}`}>{appearance.Name.English}</Link>
                </List.Item>
            </Card.Content>
        );
    }
}


// WEBPACK FOOTER //
// ./src/items/detail/summary-card/AppearanceContent.jsx